import { useCallback, useEffect } from 'react'
import type { UseDropdownParams } from './types'

export const useDropdown = ({ closeOnClickOutside, isOpen, onClose }: UseDropdownParams) => {
  useEffect(() => {
    if (!!closeOnClickOutside && onClose === undefined) {
      //eslint-disable-next-line
      console.error(
        'Warning (Dropdown): You should provide an onClose function when closeOnClickOutside=true , to keep your controller state consistent'
      )
    }
  }, [closeOnClickOutside, isOpen, onClose])

  const onClickOutside = useCallback(() => {
    if (closeOnClickOutside) {
      onClose && onClose()
    }
  }, [closeOnClickOutside, onClose])

  const handleClose = useCallback(() => {
    if (!onClose) return
    onClose()
  }, [onClose])

  return { handleClose, onClickOutside }
}
